import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import TableComponent from 'app/components/TableComponent';
import './styles/ajustes.css';
import { getAllPeriodsStatus } from 'app/service/bonos/Ajustes';

type PeriodStatus = {
  id: number;
  month: string;
  period: string;
  yearPeriod: number;
  statusPeriod: number;
}

const heads = [
  { code: 'month', label: 'Mes' },
  { code: 'period', label: 'Periodo' },
  { code: 'yearPeriod', label: 'Año' },
  { code: 'statusPeriod', label: 'Estado' },
];

const Ajustview: React.FC = () => {
   const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(5);
  
    const [periodStatus, setPeriodStatus] = useState<PeriodStatus[]>([]);
  
    const [loadingGrid, setLoadingGrid] = useState(true);
    const [loadingInfo, setLoadingInfo] = useState(false);
  
    const fetchPeriodsStatus = async () => {
      try {
        const res = await getAllPeriodsStatus(currentPage, pageSize);
        setPeriodStatus(
          res.records.map((record) => ({
            ...record,
          }))
        );
        setLoadingInfo(!loadingInfo);
        setTotalRecords(res.totalRecords);
        setLoadingGrid(false);
      } catch (err) {
        console.error("Error al obtener PeriodsStatus", err)
      }
    }
  
    useEffect(() => {
      fetchPeriodsStatus();
    }, [currentPage, pageSize]);
  
    const rows = useMemo(() => {
      if (!loadingGrid && periodStatus.length) {
        return periodStatus.map((row) => ({
          month: (
            <div
              style={{ textAlign: 'center' }}
            >
              {row.month}
            </div>
          ),
          period: (
            <div style={{ textAlign: 'center' }}>
              {row.period}
            </div>
          ),
          yearPeriod: (
            <div style={{ textAlign: 'center' }}>{row.yearPeriod}</div>
          ),
          statusPeriod: (
            <div style={{ textAlign: 'center', cursor: 'pointer' }}
              className={
                row.statusPeriod === 1
                  ? "text-info"
                  : "text-danger"
              }
            >{row.statusPeriod === 1 ? <Link className='text-info' to="/configuracion/ajuste-nomina">EN TRAMITE</Link> : 'FINALIZADO'}</div>
          ),
        }));
      }
      return [];
    }, [periodStatus, loadingGrid]);

  return (
    <div className="row gy-5 g-xl-8">
      <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
        <div className="card card-flush p-5">
          <h3 className="fw-bold fs-4 mb-5">Ajustes</h3>
          <TableComponent
            heads={heads}
            rows={rows}
            rowsPerPage={pageSize}
            page={currentPage}
            totalRows={totalRecords}
            setPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export { Ajustview };
